<template>
  <view-member />
</template>

<script>
import ViewTeams from "@/components/Team/ViewTeams";
export default {
  name: "MemberView",
  components: {
    "view-member": ViewTeams,
  },
};
</script>

<style scoped></style>
